/**
 * @module newKnowledgeBase
 */

module.exports = function() {
    // GLOBAL CONSTANTS
    // Get the current URL of the user's page
    const currentUrl = window.location.pathname;
    // Get initial hash
    const hash = window.location.hash;
    // Get all <a> elements in the menu list
    const menuLinks = document.querySelectorAll( '.anchor-menu li a' );
    // Get all aside elements
    const asideEls = document.querySelectorAll( '.article-menu aside, .tuna-hc-menu-categories aside' );

    // INIT MODULE
    initModule();

    function initModule() {
        // Disable hash temporary to update lazy load images height
        if ( hash ) {
            try {
                const decodedHash = decodeURIComponent( hash );
                const el = document.querySelector( decodedHash );

                if ( el ) {
                    // Remove the hash without reloading the page
                    history.replaceState( null, '', window.location.pathname + window.location.search );

                    setTimeout( () => {
                        // Restore the hash in the URL (this will cause scroll)
                        window.location.hash = decodedHash;
                        setHeightOfArticleImages();
                        scrollToCurrentAnchor();
                        updateAsideTop();
                    }, 2000 );
                }
            } catch ( e ) {
                console.error( `Invalid selector or hash: ${hash}`, e );
            }
        } else {
            setHeightOfArticleImages();
            scrollToCurrentAnchor();
            updateAsideTop();
        }

        // Check each item in the list
        menuLinks.forEach( function( link ) {
            // Get the URL of the list item
            const linkUrl = link.getAttribute( 'href' );
            const compareSlug = link.getAttribute( 'data-compare-slug' );

            // Check if the current URL starts with the URL of the list item
            if ( currentUrl.startsWith( linkUrl ) || ( compareSlug && currentUrl.includes( compareSlug ) ) ) {
                link.classList.remove( 'text-secondary' );
            }
        } );

        // Check if articles widget have a bigger height then 80vh
        const widget = document.querySelector( '.articles-widget' );

        if ( widget ) {
            const anchorMenu = widget.querySelector( '.anchor-menu' );

            if ( widget.offsetHeight > window.innerHeight * 0.7 ) {
                anchorMenu.classList.add( 'scrollable' );
            }
        }

        initModuleEvents();
    }

    // Calculate navbar header height
    function calculateHeaderHeight() {
        const header = document.querySelector( '.navbar.sticky-top' );
        const headerHeight = header.offsetHeight;
        const scrollTitleMarginTop = 40;

        return headerHeight + scrollTitleMarginTop;
    }

    // Update aside top
    function updateAsideTop() {
        // Calculate offset header
        const offsetHeader = calculateHeaderHeight();

        asideEls.forEach( ( el ) => {
            el.style.top = offsetHeader + 'px';
        } );
    }

    // Fix smooth scrolling with lazy load images
    function setHeightOfArticleImages() {
        const lazyImages = document.querySelectorAll( '.anchor-menu-content img' );

        lazyImages.forEach( ( img ) => {
            const srcset = img.getAttribute( 'srcset' ) || img.getAttribute( 'data-srcset' );
            let originalWidth = null;
            let originalHeight = null;

            if ( srcset ) {
                const entries = srcset.split( ',' ).map( ( entry ) => entry.trim() );

                // Find the entry that contains 1024w - basic for desktop screens
                const targetEntry = entries.find( ( entry ) => entry.includes( '1024w' ) );

                if ( targetEntry ) {
                    const filename = targetEntry.split( ' ' )[ 0 ];
                    const match = filename.match( /-(\d+)x(\d+)\.(jpg|jpeg|png|webp)/i );

                    if ( match ) {
                        originalWidth = parseInt( match[ 1 ] );
                        originalHeight = parseInt( match[ 2 ] );
                    }
                }
            }

            //  If script can't find precise size in data-srcset then fallback to attributes - less precise <html> height
            if ( ! originalWidth || ! originalHeight ) {
                originalWidth = parseFloat( img.getAttribute( 'width' ) );
                originalHeight = parseFloat( img.getAttribute( 'height' ) );
            }

            // Get client width
            const currentWidth = img.clientWidth;

            if ( originalWidth && originalHeight && currentWidth > 0 ) {
                // Calculate height based on client width
                const currentHeight = Number(
                    ( currentWidth / ( originalWidth / originalHeight ) ).toFixed( 3 )
                );

                // Use DOM properties to set attributes
                img.width = currentWidth;
                img.height = currentHeight;

                // Force with inline style for better precise <html> height after scroll and lazy load
                img.style.width = currentWidth + 'px';
                img.style.height = currentHeight + 'px'; // hard set
            }
        } );
    }

    // Reset height style (hard set) if page resized
    function resetHeightOfArticleImages() {
        const lazyImages = document.querySelectorAll('.anchor-menu-content img');

        lazyImages.forEach( ( img ) => {
            img.style.height = 'auto';
        } );
    }

    function scrollToCurrentAnchor() {
        const currentHash = window.location.hash;
        const targetId = currentHash.replace( '#', '' );
        const targetElement = document.getElementById( targetId );

        if ( targetElement ) {
            window.scrollTo( {
                top: targetElement.offsetTop,
                behavior: 'smooth',
            } );
        }
    }

    function initModuleEvents() {
        // Update hash on scroll
        window.addEventListener( 'scroll', function() {
            const articleTitles = document.querySelectorAll( '.anchor-menu-content h2' ); // Get all article titles
            const menuItems = document.querySelectorAll( '.anchor-menu li a' ); // Get all menu items

            // Preserve the current bold item
            const currentMenuItem = document.querySelector( '.anchor-menu li a.active' );

            // Find which article title is at the top of the window
            let currentTitle = '';
            for ( const title of articleTitles ) {
                const rect = title.getBoundingClientRect();
                if ( rect.bottom > 0 && rect.bottom <= window.innerHeight ) {
                    currentTitle = title.textContent.trim();
                    break; // Stop after finding the first visible title
                }
            }

            // If there is a next title, change classes
            if ( currentTitle ) {
                // Remove "fw-bold" class from current bold item if it exists
                if ( currentMenuItem ) {
                    currentMenuItem.classList.remove( 'active' );
                }
                // Find the new bold item and add "fw-bold" class to it
                menuItems.forEach( function( item ) {
                    const menuItemTitle = item.textContent.trim();
                    if ( menuItemTitle === currentTitle ) {
                        item.classList.add( 'active' );
                        // Update the URL in the address bar
                        const newUrl = new URL( window.location );
                        newUrl.hash = item.getAttribute( 'href' );
                        history.pushState( null, '', newUrl );
                    }
                } );
            }
        } );

        // Add event listener to anchor menu items for the click event
        document.querySelectorAll( '.anchor-menu li a' ).forEach( function( anchor ) {
            anchor.addEventListener( 'click', function( event ) {
                event.preventDefault(); // Prevent the default anchor click behavior

                const targetId = this.getAttribute( 'href' ).substring( 1 );
                const targetElement = document.getElementById( targetId );

                if ( targetElement ) {
                    window.scrollTo( {
                        top: targetElement.offsetTop,
                        behavior: 'smooth',
                    } );
                }
            } );
        } );

        // Make changes on window resize
        let resizeTimeout;
        window.addEventListener( 'resize', () => {
            clearTimeout( resizeTimeout );
            resizeTimeout = setTimeout( () => {
                resetHeightOfArticleImages();
                updateAsideTop();
                scrollToCurrentAnchor();
            }, 200 );
        } );
    }
}; // exports
